import { render, staticRenderFns } from "./tiptap.vue?vue&type=template&id=0076d714&"
import script from "./tiptap.vue?vue&type=script&lang=js&"
export * from "./tiptap.vue?vue&type=script&lang=js&"
import style0 from "./tiptap.vue?vue&type=style&index=0&id=0076d714&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports